import { get, post, del } from ".";

let selfPromise = {};

export const getSelf = async (projectId) => {
  if (selfPromise[projectId]) {
    return selfPromise[projectId];
  }
  // Start a new refresh and store the promise
  selfPromise[projectId] = get(`user/self${projectId ? `?projectId=${projectId}` : ``}`)
    .then((data) => {
      return data;
    })
    .finally(() => {
      selfPromise[projectId] = null; // Reset after done
    });
  return selfPromise[projectId];
};

// export const getSelf = async (projectId) => {
//   return await get(`user/self${projectId ? `?projectId=${projectId}` : ``}`);
// };

export const localLogin = async (username, password) => {
  return await post(
    `auth/token`,
    {
      grant_type: "password",
      username: username,
      password: password,
    },
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }
  );
};

export const requestResetPassword = async (email) => {
  return await get(`user/password/request-reset?email=${email}`);
};

export const validateRequest = async (requestId) => {
  return await get(`user/password/validate-request?requestId=${requestId}`);
};

export const resetPassword = async (requestId, password) => {
  return await post(`user/password/reset?requestId=${requestId}&password=${password}`);
};

export const getAllUserApi = async (companyId) => {
  return await get(`user/all${companyId ? `?companyId=${companyId}` : ``}`);
};

export const getUserDetailsApi = async (userId) => {
  return await get(`user?userId=${userId}`);
};

export const updateUserDetailsApi = async (params) => {
  return await post(`user/update-user`, params);
};

export const reactiveUserApi = async (userId) => {
  return await post(`user/reactive-user?userId=${userId}`);
};

export const disableUserApi = async (userId) => {
  return await del(`user/disable-user?userId=${userId}`);
};

export const registerUserApi = async (params) => {
  return await post(`user/register`, params);
};
